import { QueryClient } from '@tanstack/react-query';

// Backend now serves a delta-synced cache, so the frontend doesn't need to
// stampede refetches on every focus/mount. 30s staleTime + reconnect-only
// refetch keeps data fresh without piling on requests during refresh storms.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30,
      cacheTime: 1000 * 60 * 30,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
    },
  },
});
